import { motion, useReducedMotion } from "motion/react";
import { YEATIES_CONSENT_MOTION } from "@/features/card/configs/yeatiesConsent.config";
import { getReducedMotionFallback } from "@/features/card/utils/yeatiesConsentMotion.util";

const CHECK_PATH = "M5 13l4 4L19 7";
const CHECK_SIZE = 28;
const CHECK_STROKE_WIDTH = 2.5;

export const YeatiesAcceptedCheck = () => {
  const reduceMotion = useReducedMotion();

  return (
    <svg
      width={CHECK_SIZE}
      height={CHECK_SIZE}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={CHECK_STROKE_WIDTH}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className="shrink-0"
    >
      <motion.path
        d={CHECK_PATH}
        {...getReducedMotionFallback(reduceMotion, { from: { pathLength: 0 }, to: { pathLength: 1 }, transition: YEATIES_CONSENT_MOTION.checkDraw })}
      />
    </svg>
  );
};
